const CASHIER_USA_SUBDIVISIONS_WE_USE_AS_COUNTRIES = ['AS',
// American Samoa
'FM',
// Micronesia,
'GU',
// Guam,
'MP',
// Northern Mariana Islands,
'PW',
// Palau,
'VI',
// U.S. Virgin Islands
'PR' // Puerto Rico,
];
export function cashierExpressAddressToEcomAddress(shippingAddress, billingAddress) {
  if (shippingAddress === void 0) {
    shippingAddress = {};
  }
  if (billingAddress === void 0) {
    billingAddress = {};
  }
  let countryCodeOverride = null;
  let hasSubdivision = !!shippingAddress.state;
  if (shippingAddress.countryCode === 'C2') {
    countryCodeOverride = 'CN';
  }
  if (shippingAddress.countryCode === 'US' && shippingAddress.state && CASHIER_USA_SUBDIVISIONS_WE_USE_AS_COUNTRIES.includes(shippingAddress.state)) {
    countryCodeOverride = shippingAddress.state;
    hasSubdivision = false;
  }
  const country = countryCodeOverride ?? shippingAddress.countryCode ?? billingAddress.countryCode;
  return {
    country,
    city: shippingAddress.city,
    zipCode: shippingAddress.postalCode,
    addressLine1: shippingAddress.addressLine1,
    addressLine2: shippingAddress.addressLine2,
    name: {
      firstName: shippingAddress.firstName ?? billingAddress.firstName,
      lastName: shippingAddress.lastName ?? billingAddress.lastName
    },
    subdivision: hasSubdivision ? `${country}-${shippingAddress.state}` : undefined,
    email: billingAddress.email,
    phoneNumber: shippingAddress.phone || billingAddress.phone
  };
}
//# sourceMappingURL=cashierExpressAddressToEcomAddress.js.map